const asset_server_url = process.env.REACT_APP_IMAGE_BASE_URL
const configs = {
    asset_server_url,
    defaultRoot: '/tagdashboard/index'
}
export default configs